<template>
  <el-pagination @current-change="changePage" @size-change="handleSizeChange" :current-page="page"
    :page-size="pageSize" background class="pager mt-4" :disabled="disabledFlag" :page-sizes="pageSizes" :layout="layout"
    :total="total">
  </el-pagination>
</template>

<script>
import { Pagination } from 'element-ui';

export default {
  name: 'Pager',
  components: {
    'el-pagination': Pagination
  },
  props: {
    // 分页配置项，设置属性名
    props: {
      type: Object,
      default: () => {
        return {
          page: 'page',
          pageSize: 'pageSize',
          total: 'total',
        }
      }
    },
    /**
     * 分页属性
     * 属性名为value，可自动绑定input事件，传出到父组件
     */
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    /**
     * 页码大小
     */
    pageSizes: {
      type: Array,
      default: () => { return [10, 20, 50, 100]; }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
  },
  data() {
    return {
      config: {
        page: 'page',
        pageSize: 'pageSize',
        total: 'total',
      },
      disabledFlag: false,
      pager: {},
    };
  },
  watch: {
    // 配置
    props: {
      handler(val) {
        if (val) {
          this.config = { ...this.config, ...val }
        }
      },
      immediate: true
    },
  },
  computed: {
    page() {
      return this.value[this.config.page] || 1
    },
    pageSize() {
      return this.value[this.config.pageSize] || 20
    },
    total() {
      return this.value[this.config.total] || 0
    },
  },
  methods: {
    /**
     * 翻页
     */
    changePage(num) {
      this.disabledFlag = true;
      setTimeout(() => {
        this.disabledFlag = false;
      }, 300);
      const pager = { ...this.value };
      pager[this.config.page] = num;
      this.$emit('input', pager);
      this.$emit('change');
    },
    /**
     * 页码
     */
    handleSizeChange(num) {
      this.disabledFlag = true;
      setTimeout(() => {
        this.disabledFlag = false;
      }, 300);
      const pager = { ...this.value };
      pager[this.config.page] = 1;
      pager[this.config.pageSize] = num;
      this.$emit('input', pager);
      this.$emit('change');
    },
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.pager {
  padding: 0;
  text-align: center;
}
</style>
